import React, { useEffect } from "react";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import { makeStyles, useTheme } from "@material-ui/core/styles";

import LeftMenuLayout from "./leftMenuLayout";
import RightMenuDrawer from "./rightMenuLayout";
import Index from "../routes";
import { AuthService } from "../services/auth.service";
import { Role } from "../_utils/roleEnum";

const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },

  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  menuButton: {
    marginTop: -100,
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  staticBar: {
    backgroundColor: "#f7faff",
    height: 80,
    borderStyle: "solid",
  },
  drawerPaper: {
    width: drawerWidth,
    background: "#070d59",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));

function DashboardLayout({ window }) {
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);
  const [currentUser, setCurrentUser] = React.useState(false);
  const [isAdmin, setIsAdmin] = React.useState(undefined);

  useEffect(() => {
    AuthService.currentUser.subscribe((currentUser) => {
      setCurrentUser(currentUser);
      setIsAdmin(currentUser && currentUser.roleId === Role.Admin);
    });
  }, []);

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <div className={classes.root}>
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          className={classes.menuButton}
        >
          <MenuIcon color="secondary" />
        </IconButton>
      </Toolbar>

      <nav className={classes.drawer} aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === "rtl" ? "right" : "left"}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            <LeftMenuLayout />
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            <LeftMenuLayout />
          </Drawer>
        </Hidden>
      </nav>

      <main className={classes.content}>
        {/**
           * TODO moverlo a la sección de ventas
          <AppBar className={classes.staticBar} position="static"></AppBar>
        */}
        <div className={classes.toolbar} />
        <Index />
      </main>
      <RightMenuDrawer
        currentUser={currentUser}
        isAdmin={isAdmin}
      ></RightMenuDrawer>
    </div>
  );
}

export default DashboardLayout;
